import { ApiKey, DepreactedApiKey } from "./api-key.type";
import { ApiKeysService } from "./api-keys.service";
import {SnackBarService} from "@teammood/shared/ui/snack-bar";
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LoggerService } from "@teammood/shared/util/logger";
import { catchError, EMPTY, Subject, takeUntil, tap } from "rxjs";

@Component({
    selector: "api-keys",
    templateUrl: "./api-keys.component.html",
    providers: [
        ApiKeysService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApiKeysComponent implements OnInit, OnDestroy {

    apiKeys: ApiKey[];
    deprecatedApiKeys: any;

    private _destroy$ = new Subject<void>();

    constructor(
        private logger: LoggerService,
        private apiKeysService: ApiKeysService,
        private snackBarService: SnackBarService,
    ) {}

    ngOnInit() {

        this.apiKeysService.getAPIKeys().pipe(
            tap(apiKeys => this.apiKeys = apiKeys),
            catchError(err => {
                this.logger.error(err);
                this.snackBarService.error(err);
                return EMPTY;
            }),
            takeUntil(this._destroy$)
        ).subscribe();

        this.apiKeysService.getDeprecatedAPIKeys().pipe(
            tap(deprecatedApiKeys => {
                this.deprecatedApiKeys = deprecatedApiKeys;
            }),
            catchError(err => {
                this.logger.error(err);
                this.snackBarService.error(err);
                return EMPTY;
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    protected displayDeprecatedApiKey(key: DepreactedApiKey) {
        return "Authorization: Basic "+ btoa(key.teamId + ":" + key.value);
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    addKey() {
        this.apiKeysService.newAPIKey().pipe(
            tap(keys => {
                this.apiKeys = keys;
                this.snackBarService.success('New key created successfully');
            }),
            catchError(error => {
                this.logger.error(error);
                this.snackBarService.error(error);
                return EMPTY;
            })
        ).subscribe();
    }

    delete (apiKey: ApiKey) {
        this.apiKeysService.deleteAPIKey(apiKey).pipe(
            tap(keys => {
                this.apiKeys = keys;
                this.snackBarService.success('Key removed successfully');
            }),
            catchError(error => {
                this.logger.error(error);
                this.snackBarService.error(error);
                return EMPTY;
            })
        ).subscribe();
    }

    renew (apiKey: ApiKey) {
        this.apiKeysService.renewAPIKey(apiKey).pipe(
            tap(keys => {
                this.apiKeys = keys;
                this.snackBarService.success('Key renewed successfully');
            }),
            catchError(error => {
                this.logger.error(error);
                this.snackBarService.error(error);
                return EMPTY;
            })
        ).subscribe();
    }

    copyKey (key: string) {
        navigator.clipboard.writeText(key)
            .catch(error => {
                this.logger.error(error);
                this.snackBarService.error(error);
            });
        this.snackBarService.success(`Key '${key}' copied to clipboard`)
    }
}